import { isDev } from '../util/isDev';
import { postKiosk } from './postKioskApi';
import { postKioskMock } from './postKioskApi.mock';

export function usePostKioskApi() {
  return isDev() ? postKioskMock : postKiosk;
}
